import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { prepareCommonLinearData, sendLinear } from "~/features/configurator/Linear/api/sendLinearCommon";
import { prepareApiDataForUpdate } from "~/features/configurator/common/commonConfiguratorApi";
import { type KmatType } from "~/features/configurator/Linear/kmatType";

export type CsticUpdate = {
  key: string;
  type: KmatType;
  index?: number;
  value: string | null;
};

export function sendLinearUpdate(
  linearState: LinearConfiguratorState,
  updatedCstics: CsticUpdate[],
): Promise<LinearConfiguration> {
  const data = prepareCommonLinearData(linearState);

  const updateData = prepareApiDataForUpdate(linearState, updatedCstics);

  return sendLinear({
    ...data,
    ...updateData,
  });
}
